import ReviewTypes from '../Types/ReviewTypes';

import { formatError } from '../../services/AppService';
import ReviewService from '../../services/API/ReviewService';

const DEFAULT_TIMEOUT = 5000;

export default function(state, dispatch) {
  function _dispatch(type, payload) {
    dispatch({ type, payload });
  }

  const _resetError = () => {
    _dispatch(ReviewTypes.RESET_ERROR);
  };

  const setError = (error, isAutoCancel = true, timeout) => {
    dispatch(ReviewTypes.SET_ERROR, { error: formatError(error) });
    if (isAutoCancel) {
      setTimeout(() => {
        _resetError();
      }, timeout || DEFAULT_TIMEOUT);
    }
  };

  const toggleReview = payload => {
    _dispatch(ReviewTypes.TOGGLE_ADD_REVIEW, false);
    _dispatch(ReviewTypes.TOGGLE_REVIEW, payload);
  };

  const toggleAddReview = payload => {
    _dispatch(ReviewTypes.TOGGLE_REVIEW, false);
    _dispatch(ReviewTypes.TOGGLE_ADD_REVIEW, payload);
  };

  const submitReview = payload => {
    _dispatch(ReviewTypes.IS_SUBMITTING_REVIEW, true);

    ReviewService.postReview(payload)
      .then(() => {})
      .catch(error => {
        console.log('Error review submission==>', error);
      })
      .finally(() => {
        _dispatch(ReviewTypes.IS_SUBMITTING_REVIEW, false);
        toggleAddReview(false);
      });
  };

  const fetchReviewByJobWorkId = jobCityWorkLocationId => {
    _dispatch(ReviewTypes.IS_FETCHING_REVIEWS, true);
    ReviewService.getReviews({ jobCityWorkLocationId })
      .then(response => {
        _dispatch(ReviewTypes.SET_REVIEWS, response);
      })
      .catch(error => {
        console.log('Error reviews fetching==>', error);
      })
      .finally(() => {
        _dispatch(ReviewTypes.IS_FETCHING_REVIEWS, false);
      });
  };

  const upVoteReview = reviewId => {
    _dispatch(ReviewTypes.IS_SUBMITTING_VOTE, true);
    ReviewService.storeVotes({ reviewId, voteType: 'upvotes' })
      .then(response => {
        _dispatch(ReviewTypes.SET_REVIEWS, response);
      })
      .catch(error => {
        console.log('Error reviews fetching==>', error);
      })
      .finally(() => {
        _dispatch(ReviewTypes.IS_SUBMITTING_VOTE, false);
      });
  };

  const downVoteReview = reviewId => {
    _dispatch(ReviewTypes.IS_SUBMITTING_VOTE, true);
    ReviewService.storeVotes({ reviewId, voteType: 'downvotes' })
      .then(response => {
        _dispatch(ReviewTypes.SET_REVIEWS, response);
      })
      .catch(error => {
        console.log('Error reviews fetching==>', error);
      })
      .finally(() => {
        _dispatch(ReviewTypes.IS_SUBMITTING_VOTE, false);
      });
  };

  return {
    setError,
    toggleReview,
    toggleAddReview,
    submitReview,
    fetchReviewByJobWorkId,
    upVoteReview,
    downVoteReview,
  };
}
